import pdfPackage from 'pdfjs-dist/package.json';

export const PDF_BASE = `${process.env.PUBLIC_URL || ''}/pdfjs/${pdfPackage.version}`;
let pdfLibrary;

export function loadPdfLibrary() {
  if (!pdfLibrary) {
    const src = `${PDF_BASE}/pdf.min.js`;
    pdfLibrary = import(/* webpackIgnore: true */ src).then((pdf) => {
      pdf.GlobalWorkerOptions.workerSrc = `${PDF_BASE}/pdf.worker.min.js`;
      return pdf;
    }).catch((error) => { pdfLibrary = null; throw error; });
  }
  return pdfLibrary;
}

export async function readPdfPageText(page, signal) {
  const checkCancelled = () => {
    if (signal?.aborted) throw new DOMException('Page changed', 'AbortError');
  };
  checkCancelled();
  // PDF.js 6 getTextContent uses ReadableStream[Symbol.asyncIterator], which
  // shipped Safari versions lack, including in the legacy build (#21557).
  // Consume the public stream API through its widely supported reader instead.
  const reader = page.streamTextContent().getReader();
  const cancel = () => { reader.cancel().catch(() => {}); };
  signal?.addEventListener('abort', cancel, { once: true });
  const chunks = [];
  try {
    for (;;) {
      const { value, done } = await reader.read();
      checkCancelled();
      if (done) break;
      chunks.push(value.items.map((item) => `${item.str || ''}${item.hasEOL ? '\n' : ' '}`).join(''));
    }
    return chunks.join('');
  } finally {
    signal?.removeEventListener('abort', cancel);
    reader.releaseLock();
  }
}
